/**
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2020, 2021
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

/**
 * @class AffinityServiceAPI
 * @hideconstructor
 * @classdesc API class to send affinity request and manage the affinity ids.
 */
define([], () => {

	class AffinityServiceAPI {

		/** String constant required and returned by server */
		static AFFINITY_CONTEXT = {
			CONTEXT_ID: 'x-qs-querycontext-id', /** Context ID header name */
			AFFINITY_ID: 'x-ca-affinity', /** Affinity header name */
			REQUEST_ID: 'x-qs-request-id', /** Request id header name */
			ROUTING_ID: 'x-ca-routing' /** Routing id header name */
		};

		/**
		 * @function AffinityServiceAPI#getAffinityContext
		 * @description Get affinity context of the current dashboard. Send query context request if does not exist.
		 * @public
		 * @async
		 *
		 * @return {Promise<Object>} Returns a promise that will be resolved to an object with affinityId and queryContextId.
		 * @extends
		 *
		 */
		getAffinityContext() {}

		/**
		 * @function AffinityServiceAPI#generateRequestID
		 * @description Generate and return a unique id for the current request.
		 * @public
		 *
		 * @returns {String} Unique string ID.
		 */
		generateRequestID() {}

		/**
		 * @function AffinityServiceAPI#resetAffinity
		 * @description Establish a new affinity and query context for the service.
		 * @public
		 * @param {Object} - affinityInfo contains routingInfo
		 */
		resetAffinity() {}

	}

	return AffinityServiceAPI;
});
